<script>
import NoResults from '../shared/NoResults.vue';
import LoadingRing from '../shared/LoadingRing.vue';
import { Slider } from 'vue-sliderx';
import GamesGrid from '../shared/GamesGrid';

export default {
  name: 'GameSearchBox',
  components: {
    GamesGrid,
    NoResults,
    LoadingRing,
    Slider,
  },
  props: {
    games: {},
    loading: {
      type: Boolean,
    },
    searchEnabled: {
      required: true,
    },
  },
  computed: {
    gridToDisplay () {
      return Math.trunc(this.games.length / 8) + 1; // 4 x 2 grid
    },
  },
  methods: {
    getGridGames (index) {
      return this.games.slice(index * 8, index * 8 + 8);
    },
  },
};
</script>

<template lang="pug">
div.game-search-box.bg-black-overlay.animated.fadeIn.white.relative.flex.flex-column._collision
  header.cf.ph4.pt3.mt1
    launcher-router-link.fr.f6.pa1.bg-green.absolute.top-0.right-0.h-glow.z-1(:to="{ name: 'games-index' }")
      icon.w15.fill-black(name="x")
    h3.fw7.ttu.f5 {{ $t('Search results') }}
  transition(mode="out-in", enter-active-class="fadeIn animated-200", leave-active-class="fadeOut animated-200")
    div.status.tc(v-if="!searchEnabled", key="init")
      icon.searchicon.w3.mv4.center.db.fill-white.o-20(name="search")
    loading-ring.center.mv4(v-else-if="loading", key="loading")
    div.results.tc.flex-auto.flex.items-stretch.justify-center(v-else, key="result")
      no-results(v-if="!games.length")
        i18n(path="Enter something else or go back to the { game list }")
          link-style
            launcher-router-link(place="game list", :to="{ name: 'games-index' }") {{ $t('game list') }}
      slider.slider.flex-auto(:per-page="1", v-else, :clone="false", :loop="false")
        arrow-button.prevbtn.center.db.absolute.top-0.left-50.z-1(small, slot="prev", slot-scope="{ canPrev, prev, index }", @click="prev", :style="{visibility: canPrev && index > 0 ? 'visible': 'hidden'}")
        GamesGrid.gamegrid.ph4.pv3(:col="4" :rows="2" :games="getGridGames(i-1)", v-for="i in gridToDisplay", :key="i")
        arrow-button.nextbtn.center.db.absolute.bottom-0.left-50.z-1.translate-x--50(small, slot="next", slot-scope="{ canNext, next }", @click="next", :style="{visibility: canNext && gridToDisplay > 1 ? 'visible': 'hidden'}")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.game-search-box {
  & .searchicon {
    width: 100px;
  }
  & .slider {
    /* padding-top: 6.2rem; */
    position: static !important;
    & >>> .prevbtn {
      transform: rotate(180deg) translateX(50%);
    }
  }
}
</style>
